// core version + certain modules modules:
import SwiperCore, {Navigation, Pagination, Autoplay, EffectFade, Controller, A11y} from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, A11y]);

const Swipers = {}

Swipers.logoSlider = new SwiperCore('.logo-slider', {
    autoplay: {
        delay: 0,
    },
    loop: true,
    a11y: true,
    speed: 5000,
    slidesPerView: 3,
    spaceBetween: 0,
    loopFillGroupWithBlank: true,
    breakpoints: {
        992: {
            slidesPerView: 8,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 0,
        },
    }
});

if (window.innerWidth > 767) {

    Swipers.fullWidthSlider = new SwiperCore('.full-width-slider', {
        autoplay: false,
        loop: false,
        a11y: true,
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: true,
        loopAdditionalSlides: 1,
        pagination: {
            el: ".full-width-slider__pagination",
        },
    })

    Swipers.postsSlider = new SwiperCore('.posts-slider--row', {
        autoplay: false,
        loop: false,
        a11y: true,
        slidesPerView: 1.5,
        spaceBetween: 16,
        pagination: {
            el: ".posts-slider__pagination",
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
        }
    })

    Swipers.postsSlider = new SwiperCore('.posts-slider--single', {
        autoplay: false,
        loop: true,
        a11y: true,
        slidesPerView: 4,
        spaceBetween: 16,
        effect: "fade",
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
            },
        }
    })
}
